import { render, staticRenderFns } from "./AllocationCell.vue?vue&type=template&id=10d0a8a0&scoped=true&"
import script from "./AllocationCell.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AllocationCell.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AllocationCell.vue?vue&type=style&index=0&id=10d0a8a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0a8a0",
  null
  
)

export default component.exports